export const translations = {
  de: {
    nav: {
      home: 'Home',
      services: 'Leistungen',
      gallery: 'Galerie',
      contact: 'Kontakt',
      booking: 'Termin buchen',
    },

    hero: {
      eyebrow: 'African Braids • Cornrows • Dreadlocks',
      title: 'Be your own crown.',
      subtitle:
        'Afro Hair, Braids, Cornrows und African Style. Frage deinen Termin bequem online an – schnell, modern und direkt per WhatsApp.',
      primary: 'Termin buchen',
      secondary: 'Galerie ansehen',
      rating: 'Zufriedene Kundinnen & Kunden',
      badgeTitle: 'Studio in Neunkirchen',
      badgeText: 'Persönliche Beratung, echte Styles und Kenyan Spirit.',
    },

    booking: {
      eyebrow: 'Wichtigster Bereich',
      title: 'Online Termin buchen',
      text:
        'Wähle Service, Datum und Uhrzeit. Danach öffnet sich WhatsApp mit deiner fertigen Anfrage.',
      spamInfo: 'Deine Anfrage wird sicher vorbereitet und erst über WhatsApp versendet.',
      step1: 'Service wählen',
      step2: 'Datum wählen',
      step3: 'Zeit wählen',
      step4: 'Daten eingeben',
      name: 'Dein Name',
      phone: 'Telefonnummer *',
      email: 'E-Mail optional',
      note: 'Wunsch / Hinweis optional',
      submit: 'Termin per WhatsApp anfragen',
      botHint: 'Buchung frühestens ab morgen',
      timeHint: 'Wunschzeit zwischen',
      clock: 'Uhr',
      closedHint: 'An diesem Tag ist das Studio geschlossen. Bitte wähle einen anderen Tag.',
      error: 'Bitte Name, Telefonnummer, Datum und Uhrzeit vollständig ausfüllen.',
      closedError: 'An diesem Tag ist das Studio geschlossen. Bitte wähle einen anderen Tag.',
      timeError: 'Bitte wähle eine Uhrzeit innerhalb der Öffnungszeiten.',
      priceFrom: 'ab',
    },

    services: {
      title: 'Unsere Leistungen',
      subtitle: 'Styles, Pflege und Beratung',
      priceFrom: 'ab',
      more: 'Termin anfragen',
    },

    gallery: {
    title: 'Unsere Arbeit',
    subtitle: 'Styles mit Gefühl, Erfahrung und Charakter',
    button: 'Termin anfragen',
    },

    contact: {
      title: 'Kontakt & Öffnungszeiten',
      subtitle: 'Schnell erreichbar per WhatsApp',
      aboutTitle: 'Über uns',
      about:
        'Hakuna Matata steht für afrikanische Schönheit, Tradition und moderne Styles. Persönliche Beratung, saubere Arbeit und viel Liebe zum Detail.',
      hoursTitle: 'Öffnungszeiten',
      contactTitle: 'Kontakt',
      whatsapp: 'WhatsApp schreiben',
    },

    footer: {
      imprint: 'Impressum',
      privacy: 'Datenschutz',
    },

    legal: {
      imprintTitle: 'Impressum',
      privacyTitle: 'Datenschutz',
    },
  },

  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      gallery: 'Gallery',
      contact: 'Contact',
      booking: 'Book now',
    },

    hero: {
      eyebrow: 'African Braids • Cornrows • Dreadlocks',
      title: 'Be your own crown.',
      subtitle:
        'Afro hair, braids, cornrows and African style. Request your appointment online – fast, modern and directly via WhatsApp.',
      primary: 'Book appointment',
      secondary: 'View gallery',
      rating: 'Happy clients',
      badgeTitle: 'Studio in Neunkirchen',
      badgeText: 'Personal consultation, authentic styles and Kenyan spirit.',
    },

    booking: {
      eyebrow: 'Main focus',
      title: 'Book appointment',
      text:
        'Choose service, date and time. WhatsApp then opens with your prepared appointment request.',
      spamInfo: 'Your request is prepared securely and is only sent through WhatsApp.',
      step1: 'Choose service',
      step2: 'Choose date',
      step3: 'Choose time',
      step4: 'Your details',
      name: 'Your name',
      phone: 'Phone number *',
      email: 'Email optional',
      note: 'Request / note optional',
      submit: 'Request via WhatsApp',
      botHint: 'Earliest booking from tomorrow',
      timeHint: 'Preferred time between',
      clock: '',
      closedHint: 'The studio is closed on this day. Please choose another day.',
      error: 'Please complete your name, phone number, date and time.',
      closedError: 'The studio is closed on this day. Please choose another day.',
      timeError: 'Please choose a time within the opening hours.',
      priceFrom: 'from',
    },

    services: {
      title: 'Our Services',
      subtitle: 'Styles, care and consultation',
      priceFrom: 'from',
      more: 'Request appointment',
    },

    gallery: {
    title: 'Our Work',
    subtitle: 'Styles with care, experience and character',
    button: 'Request appointment',
    },

    contact: {
      title: 'Contact & Opening Hours',
      subtitle: 'Easy contact via WhatsApp',
      aboutTitle: 'About us',
      about:
        'Hakuna Matata stands for African beauty, tradition and modern styles. Personal consultation, clean work and attention to detail.',
      hoursTitle: 'Opening hours',
      contactTitle: 'Contact',
      whatsapp: 'Write on WhatsApp',
    },

    footer: {
      imprint: 'Imprint',
      privacy: 'Privacy',
    },

    legal: {
      imprintTitle: 'Imprint',
      privacyTitle: 'Privacy Policy',
    },
  },
};
